import Request from './baseRequest'

const getUserToken = () => {
	return JSON.parse(localStorage.getItem('auth.currentUser')).token;
}

const _login = payload => {

    return Request.post(
    `${window.config.VUE_APP_BACKEND}/api/auth/login`,
    payload, { skipRetry: true }
  )
}

const _verifyDevice = payload => Request.post(
  `${window.config.VUE_APP_BACKEND}/api/auth/verify-device`, payload, { skipRetry: true }
)

const _resendDeviceCode = payload => Request.post(
  `${window.config.VUE_APP_BACKEND}/api/auth/resend-device-code`, payload, { skipRetry: true }
)

const _logout = () => {

  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.delete(
    `${window.config.VUE_APP_BACKEND}/api/auth/logout`,
    config
  )
}

const _selectCompany = companyId => {

  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(
    `${window.config.VUE_APP_BACKEND}/api/auth/select-company`,
    { companyId },
    config
  )
}

const _checkEmail = email => {

  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/auth/check-email?email=${encodeURIComponent(email)}`,
    config
  )
}

const _createUser = payload => {

  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(
    `${window.config.VUE_APP_BACKEND}/api/auth/register`,
    payload,
    config
  )
}

// New link for a collaborator that has not activated the account yet
const _resendInvite = payload => {

  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(
    `${window.config.VUE_APP_BACKEND}/api/auth/resend-invite`,
    payload,
    config
  )
}

// Public, opened from the invitation email: the one-time token is the credential
const _getInviteInfo = ({ email, token }) => {

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/auth/invite-info?email=${encodeURIComponent(email)}&token=${encodeURIComponent(token)}`
  )
}

const _acceptInvite = payload => {

  return Request.post(
    `${window.config.VUE_APP_BACKEND}/api/auth/accept-invite`,
    payload
  )
}

const _getUsers = params => { 
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  const url= params? `${window.config.VUE_APP_BACKEND}/api/users?${params.q}` : `${window.config.VUE_APP_BACKEND}/api/users`


  return Request.get(
    url,
    config
  )
}

const _deleteUser = userId => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.delete(`${window.config.VUE_APP_BACKEND}/api/users/${userId}`, config)
}

const _getUser = userId => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(`${window.config.VUE_APP_BACKEND}/api/users/${userId}`, config)
}
const _updateUser = (user) => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.put(`${window.config.VUE_APP_BACKEND}/api/users/${user._id}`, user, config)
}

const _updateUserProfile = (user) => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.put(`${window.config.VUE_APP_BACKEND}/api/auth/profile`, user, config);
}

const _getTenants = params => { 
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/tenants?${params}`,
    config
  )
}

const _createTenant = payload => {

  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(
    `${window.config.VUE_APP_BACKEND}/tenants`,
    payload,
    config
  )
}

const _removeTenant = tenantId => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.delete(`${window.config.VUE_APP_BACKEND}/tenants/${tenantId}`, config)
}

const _getCompany = companyId => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(`${window.config.VUE_APP_BACKEND}/api/companies/${companyId}`, config)
}

const _updateCompany = (company) => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.put(`${window.config.VUE_APP_BACKEND}/api/companies/${company._id}`, company, config)
}
const _requestPasswordReset= payload => {

  return Request.post(
    `${window.config.VUE_APP_BACKEND}/api/auth/request-password-reset`,
    payload, { skipRetry: true }
  )
}

// Password change from inside the session: needs the current password, and the
// backend closes every other session of the user on success
const _changePassword = payload => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(
    `${window.config.VUE_APP_BACKEND}/api/auth/change-password`,
    payload,
    config
  )
}

const _passwordReset= payload => {

  return Request.post(
    `${window.config.VUE_APP_BACKEND}/api/auth/password-reset`,
    payload, { skipRetry: true }
  )
}


export default {
  login : _login,
  verifyDevice: _verifyDevice,
  resendDeviceCode: _resendDeviceCode,
  logout : _logout,
  selectCompany : _selectCompany,
  checkEmail : _checkEmail,
  updateUser : _updateUser,
  updateUserProfile : _updateUserProfile,
  deleteUser : _deleteUser, 
  getUser : _getUser, 
  getUsers : _getUsers,
  createUser : _createUser,
  resendInvite : _resendInvite,
  getInviteInfo : _getInviteInfo,
  acceptInvite : _acceptInvite,
  
  getCompany: _getCompany,
  updateCompany: _updateCompany,
  getTenants: _getTenants,
  createTenant:_createTenant,
  removeTenant:_removeTenant,

  requestPasswordReset: _requestPasswordReset,
  passwordReset: _passwordReset,
  changePassword: _changePassword
  //getUser : _getUser,
  
  
}
